import { render, staticRenderFns } from "./Warnings.vue?vue&type=template&id=d039de7a&scoped=true&"
import script from "./Warnings.vue?vue&type=script&lang=js&"
export * from "./Warnings.vue?vue&type=script&lang=js&"
import style0 from "./Warnings.vue?vue&type=style&index=0&id=d039de7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d039de7a",
  null
  
)

export default component.exports